import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import NodeBase from './NodeBase';
import Envelope from '../../geom/Envelope';
import Assert from '../../util/Assert';
import Key from './Key';
var Node = /*#__PURE__*/function (_NodeBase) {
  _inherits(Node, _NodeBase);
  function Node() {
    var _this;
    _classCallCheck(this, Node);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this));
    Node.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(Node, [{
    key: "find",
    value: function find(searchEnv) {
      var subnodeIndex = NodeBase.getSubnodeIndex(searchEnv, this._centrex, this._centrey);
      if (subnodeIndex === -1) return this;
      if (this._subnode[subnodeIndex] !== null) {
        var node = this._subnode[subnodeIndex];
        return node.find(searchEnv);
      }
      return this;
    }
  }, {
    key: "isSearchMatch",
    value: function isSearchMatch(searchEnv) {
      if (searchEnv === null) return false;
      return this._env.intersects(searchEnv);
    }
  }, {
    key: "getSubnode",
    value: function getSubnode(index) {
      if (this._subnode[index] === null) this._subnode[index] = this.createSubnode(index);
      return this._subnode[index];
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      return this._env;
    }
  }, {
    key: "getNode",
    value: function getNode(searchEnv) {
      var subnodeIndex = NodeBase.getSubnodeIndex(searchEnv, this._centrex, this._centrey);
      if (subnodeIndex !== -1) {
        var node = this.getSubnode(subnodeIndex);
        return node.getNode(searchEnv);
      } else {
        return this;
      }
    }
  }, {
    key: "createSubnode",
    value: function createSubnode(index) {
      var minx = 0.0;
      var maxx = 0.0;
      var miny = 0.0;
      var maxy = 0.0;
      switch (index) {
        case 0:
          minx = this._env.getMinX();
          maxx = this._centrex;
          miny = this._env.getMinY();
          maxy = this._centrey;
          break;
        case 1:
          minx = this._centrex;
          maxx = this._env.getMaxX();
          miny = this._env.getMinY();
          maxy = this._centrey;
          break;
        case 2:
          minx = this._env.getMinX();
          maxx = this._centrex;
          miny = this._centrey;
          maxy = this._env.getMaxY();
          break;
        case 3:
          minx = this._centrex;
          maxx = this._env.getMaxX();
          miny = this._centrey;
          maxy = this._env.getMaxY();
          break;
      }
      var sqEnv = new Envelope(minx, maxx, miny, maxy);
      var node = new Node(sqEnv, this._level - 1);
      return node;
    }
  }, {
    key: "insertNode",
    value: function insertNode(node) {
      Assert.isTrue(this._env === null || this._env.contains(node._env));
      var index = NodeBase.getSubnodeIndex(node._env, this._centrex, this._centrey);
      if (node._level === this._level - 1) {
        this._subnode[index] = node;
      } else {
        var childNode = this.createSubnode(index);
        childNode.insertNode(node);
        this._subnode[index] = childNode;
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._env = null;
      this._centrex = null;
      this._centrey = null;
      this._level = null;
      var env = arguments[0],
        level = arguments[1];
      this._env = env;
      this._level = level;
      this._centrex = (env.getMinX() + env.getMaxX()) / 2;
      this._centrey = (env.getMinY() + env.getMaxY()) / 2;
    }
  }, {
    key: "createNode",
    value: function createNode(env) {
      var key = new Key(env);
      var node = new Node(key.getEnvelope(), key.getLevel());
      return node;
    }
  }, {
    key: "createExpanded",
    value: function createExpanded(node, addEnv) {
      var expandEnv = new Envelope(addEnv);
      if (node !== null) expandEnv.expandToInclude(node._env);
      var largerNode = Node.createNode(expandEnv);
      if (node !== null) largerNode.insertNode(node);
      return largerNode;
    }
  }]);
  return Node;
}(NodeBase);
export { Node as default };